import $ from 'jquery';
import tdaConfig from 'lib/util/tda.config';
import IsotopeFilters from 'components/offers/offers.filters';
import getParameterByName from 'lib/getParameterByName';
import AjaxOffers from 'components/ajax-offers';
import responsive from 'lib/responsive';
import bat from 'components/bat'; // bat.hcompile
import PageCache from 'lib/page-cache';
import blocks from 'lib/analytics/blocks/index';
import anComponentView from 'lib/analytics/componentView';
import anClicks from 'lib/analytics/click';
import anAddContext from 'lib/analytics/context.add';
import favorites from 'features/favorites';
import rtiDealerCode from 'lib/gxp/rtiDealerCode';
import langFromUrl from 'lib/util/langFromUrl';
import 'lib/loader/series';
import 'lib/transforms/series.mapByCode';
import 'lib/helpers/offer-bundle';
import 'components/isotope';
import removeURLParameters from 'lib/util/removeURLParameters';
import storageUtil from 'utils/storage-util';

var __SERIES_MAP = [];
var __initialized = false;

function __formatDate(date) {
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var ampm = hours >= 12 ? 'pm' : 'am';
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? '0' + minutes : minutes;
  var strTime = hours + ':' + minutes + ' ' + ampm.toUpperCase();
  return date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear() + ' ' + strTime;
}

var allOffers = {
  promoItemsMap: {},

  load: function (el, config) {
    var self = this;
    self.$el = $(el);
    self.config = config;
    self.config.i18n.lang = langFromUrl();
    PageCache.await('series.map')
      .then(function (seriesMap) {
        __SERIES_MAP = seriesMap;
        $(document).ready(function () {
          self.init();
        });
      });
  },

  init: function () {
    var self = this;
    self.promoItemsMap = {};
    self.isOffersPage = !!$('div[data-component-skin="All-Offers"]').length;
    self.offerFrame = !!$('div[data-component-skin="Framed Offers"]').length;

    if ($('#filter-promotions').length) {
      var promoItems = $('#filter-promotions div input');
      promoItems.each(function (index, element) {
        var elItem = $(element);
        self.promoItemsMap[elItem.attr('data-name')] = elItem.attr('data-param-value');
      });
    }

    var $isotopeContainer = $('#isotope-offers');
    var $isotopePrintContainer = $('#print-isotope-offers');
    var elements = [];
    var offerURLParams;

    $('#print-isotope-offers').hide();
    $isotopeContainer.isotope('remove', $isotopeContainer.find('.isotope-item')); // remove xsl cards

    function addSeries(series) {
      if (series.split(',').length > 1) {
        var seriesArr = series.split(',').map(function (item) {
          return item.trim();
        });
        for (var i = 0; i < seriesArr.length; i += 1) {
          offerURLParams += '&series=' + seriesArr[i];
        }
      } else {
        offerURLParams += '&series=' + series;
      }
    }

    /**
     * This function retrieves attribute values that are based on datums
     * and stores them in a hash that maps them to the names of query
     * string parameters used by the 'allOffers' URI
     * (the datum names are not a 1:1 match with URI parameters,
     *  hence this function)
     */
    function setOfferURLParams(attrName, paramName) {
      var attrVal = $('#all-offers').attr('data-' + attrName);
      var url_attr_param = getParameterByName(paramName);

      if (url_attr_param != null && url_attr_param !== '') {
        offerURLParams += '&' + paramName + '=' + url_attr_param;
      } else if (attrVal != null && attrVal !== '') {
        if (attrName === 'series') {
          addSeries(attrVal);
        } else {
          offerURLParams += '&' + paramName + '=' + attrVal;
        }
      }
    }

    offerURLParams = '';
    setOfferURLParams('labelcode', 'offerLabels');
    setOfferURLParams('series', 'series');
    setOfferURLParams('zipcode', 'zipCode');
    setOfferURLParams('offertype', 'offerType');
    var excludeSeries = getParameterByName('excludeSeries');
    if (excludeSeries) {
      offerURLParams += '&excludeSeries=' + excludeSeries;
    }

    var qFilters = getParameterByName('filters');
    var featured = false;
    if (qFilters && qFilters.length) {
      featured = qFilters.indexOf('featured') !== -1;
    }

    var includedParams = '';
    if (self.isOffersPage || self.offerFrame) {
      // BAT-2980 GRAB QUERY PARAMS TO BUILD PROPER REQUEST PARAMS.
      // BAT-3593 added offerFrame check.
      if (qFilters && qFilters.length) {
        var qStore = qFilters.split(',');
        var qParasString = '';
        var qType;
        var qItem;
        var qChunk;

        for (var k = 0; k < qStore.length; k += 1) {
          qItem = qStore[k];
          var mappedPromoItem = self.promoItemsMap[qItem];
          if (qItem === 'featured') {
            // ingore this.
            qType = 'featured';
            qItem = featured.toString();
            // continue;
          }
          if (__SERIES_MAP[qItem]) {
            qType = featured ? 'featuredSeries' : 'series';
          } else if (qItem === 'apr' || qItem === 'cash' || qItem === 'lease' || qItem === 'msrp' || qItem === 'misc') { // "apr", "cash", "lease", "msrp", "misc"
            qType = featured ? 'featuredType' : 'offerType';
          } else if (mappedPromoItem) {
            // BAT-3593: IF THE FILTER PARAMS ARE NOT of type 'series' or 'offerType', WE NEED TO LOOK UP THEIR VALUE
            qType = 'offerLabels';
            qItem = self.promoItemsMap[qItem];
          }
          qChunk = '&' + qType + '=' + qItem;
          qParasString += qChunk;
        }

        if (qParasString.length) {
          // offerURLParams = '&offerType=apr&series=yaris';
          // can we just pass these as url params so we don't change the service url here?
          // offerURLParams = qParasString; //DO NOT USE THIS, IT FORCES IT ONTO THE BASEURL.
          includedParams = qParasString;
        }
      }
    }

    var offersServiceUrl = '/offers-service/OFFERS/allOffers?pageSize=9' + offerURLParams;
    // console.log(offersServiceUrl);
    // BAT-2980. pass in query params to allOffersAjax instance, allowing it to create a search with filters:
    var additionalContext = { i18n: self.config.i18n, params: self.config.params };
    var allOffersAjax = new AjaxOffers(offersServiceUrl, true, true, additionalContext, $isotopeContainer, null, includedParams);
    var allOffersPrintAjax = new AjaxOffers('/offers-service/OFFERS/allOffers?' + offerURLParams, true, true, additionalContext, $isotopePrintContainer);
    var allOffersCompleteAjax = new AjaxOffers('/offers-service/OFFERS/allOffers?pageSize=9' + offerURLParams, true, true, additionalContext, $isotopeContainer);

    allOffersAjax.init();
    var allOffersFilters = new IsotopeFilters(allOffersAjax, true);

    function getNumber(str) {
      var rv = 0;
      try {
        if (str) {
          rv = str.replace(',', '') * 1;
        }
      } catch (ex) { }
      return rv;
    }

    $(allOffersAjax).on('COMPLETE', function allOffersAjaxComplete(event, $newItems, data) {
      if (rtiDealerCode.hasRti()) { // prepare data for digital garage
        self.dgOffers = [];
        if (data && data.items && data.items.length > 0) {
          const langUrl = storageUtil.getLangFromUrl() === 'es' ? 'es/' : '';
          const currentTdaCode = storageUtil.getTDA();
          const baseUrl = 'https://buyatoyota.com/';

          for (var i = 0; i < data.items.length; i += 1) {
            const offer = data.items[i];
            if (offer.offerType === 'lease' || offer.offerType === 'cash' || offer.offerType === 'apr') {
              try {
                let dgOffer = {
                  type: 'offer',
                  brand: 'Toyota',
                  dealerCd: rtiDealerCode.savedDealerCode(),
                  year: getNumber(offer.model.year),
                  marketingSeries: offer.model.name,
                  marketingNames: offer.model.trimName,
                  imageHref: baseUrl + (offer.image.src || ''),
                  offerId: offer.id,
                  offerType: offer.offerType,
                  endTime: new Date(offer.endDate).getTime(),
                  extraCashAmount: getNumber(offer.extraCashAmount),
                  disclaimers: (offer.disclaimers && offer.disclaimers.disclaimer ? offer.disclaimers.disclaimer : []) || [],
                  additionalDisclaimers: offer.additionalDisclaimers || '',
                  viewSimilarOffersHref: baseUrl + langUrl + currentTdaCode + '/offers/?filters=' + offer.model.name,
                  modelTrims: offer.model.applicableTrims || []
                };
                let extra = {};
                if (offer.offerType === 'lease') {
                  extra = {
                    dueAtSigning: getNumber(offer.lease.dueAtSigningAmount),
                    monthlyPayment: getNumber(offer.lease.monthlyPayment),
                    term: getNumber(offer.lease.duration)
                  };
                } else if (offer.offerType === 'cash') {
                  extra = {
                    cash: getNumber(offer.cash.amount)
                  };
                } else if (offer.offerType === 'apr') {
                  extra = {
                    percent: getNumber(offer.apr.rate),
                    term: getNumber(offer.apr.duration)
                  };
                }
                $.extend(dgOffer, extra);
                self.dgOffers.push(dgOffer);
              } catch (ex) { }
            }
          }
        }
      }
      if ($('#filters-panel').length === 0 && responsive() === 'lg') {
        $('#right-side').each(function () {
          this.style.setProperty('width', '100%', 'important');
        });
        $('#grid-button').hide();
        $('#list-button').hide();
        $('#right-side').css('margin-top', '30px');
      }

      var currentPageUrl = window.location.pathname;
      $('.total-found').html(data.numFound);
      $isotopeContainer.isotope('insert', $newItems);
      $isotopeContainer.isotope({
        sortBy: 'label'
      });

      $('#showing-number-of-total .number').html($isotopeContainer.children('.isotope-item:not(.isotope-hidden)').length);

      self.textFitOfferCards();
      allOffersAjax.checkDisplayShowMore();

      // Adding toggle for TDA to control this behavior GNY-199
      if (($('#defaultzipcode').attr('singleofferredirect') !== 'No') && (window.location.href.indexOf('teamsite') === -1)) {
        /* Send user directly to offer-detail page, when these conditions are met
        TODO: Since Domain Restructure, it's possible for these conditions to be met on the homepage & it looks like we wanted to prevent that
        */
        if (currentPageUrl !== '/en/#' && currentPageUrl !== '/en/' && currentPageUrl.indexOf('Home.page') === -1 && currentPageUrl.indexOf('dealer_offers_frame') === -1 && $('.total-found').html() === '1') {
          var offerId = $('.isotope-item:not(.isotope-hidden)').attr('id');
          if (offerId !== '' && offerId !== null && offerId !== 'undefined' && typeof offerId !== 'undefined' && $.trim(offerId) !== '') {
            // Redirecting when single offer = terrible idea
            window.location.href = '/' + tdaConfig.site.context_url + '/offer-detail/?offerid=' + offerId;
          }
        }
      }
      // BAT-4780
      $(document).trigger('COMPLETE_FINISH', {
        data: data
      });

      self.analyticsContext(data.numFound, allOffersFilters.allIsotopeFilters);
      __initialized = true;
      self.favListeners();
    });

    // when the hell does this one go Down, if allOffersCompleteAjax is completely overwritten on
    // display-all-offers click below?
    $(allOffersCompleteAjax).on('COMPLETE', function (event, $newItems, data) {
      $isotopeContainer.isotope('remove', $isotopeContainer.find('.isotope-item'));
      $isotopeContainer.isotope('insert', $newItems);
      $isotopeContainer.isotope({
        sortBy: 'label'
      });
      self.textFitOfferCards();
      $('#showing-number-of-total .number').html(data.items.length);
      allOffersCompleteAjax.checkDisplayShowMore();
      $('.total-found').html(data.numFound);
      $('#nav-links').css('transform', $('div.card:eq(0)').css('transform'));
      $('#nav-links').css('width', $('div.card:eq(0)').css('width'));
      $('#nav-links').find('a').css('border-top', 'none');
      $('#nav-links').find('ul').css('border-bottom', 'none');
      $('#nav-links').css('border-bottom', 'none');

      if (responsive() === 'md') {
        $('#nav-links').css('width', '490px');
      }
      // BAT-4780
      $(document).trigger('COMPLETE_FINISH', {
        data: data
      });
    });

    $(allOffersAjax).on('NO_ITEMS_FOUND', function () {
      allOffersAjax.checkNoItemsFound();
      self.analyticsContext('0', allOffersFilters.allIsotopeFilters);
    });

    $('#show-more-button').click(function (e) {
      e.preventDefault();
      allOffersAjax.showMore();
      allOffersAjax.init();
      var currentOffersNum = parseInt($('.legend-center').find('.number').text());
      var numResults = parseInt($('.legend-center').find('.number').text()) + 9;
      var totalResults = parseInt($('.legend-center').find('.total-found').text());
      if (numResults > totalResults) {
        numResults = totalResults;
      }

      // BAT-4780 SELECT THE FIRST ITEM OF THE LAST BATCH FETCHED ( FOR ADA SRT/ KEYBOARD )
      $(document).off().on('COMPLETE_FINISH', function (e, opts) {
        setTimeout(function () {
          // GIVE IT A SECOND OR TWO TO DRAW.
          var nextOffer = $('#isotope-offers .card.offer').eq(currentOffersNum).find('a'); // .find('.favorite-button'); // .find('a');
          nextOffer.focus();
        }, 2000);
      });

      // BAT-2980. update offer links with filters.
      allOffersFilters.combineFilters();
    });

    // This is crazy, why are we duplicating funcationality here?
    $('#display-all-offers').click(function (e) {
      e.preventDefault();
      var currentOffersNum = parseInt($('.legend-center').find('.number').text());
      allOffersFilters.clearFilters();
      allOffersCompleteAjax.serviceUrl = removeURLParameters(allOffersAjax.serviceUrl, ['pageSize', 'startIndex']);
      allOffersCompleteAjax = new AjaxOffers(allOffersCompleteAjax.serviceUrl, true, true, { i18n: self.config.i18n, params: self.config.params }, $isotopeContainer);

      $(document).off().on('COMPLETE_FINISH', function (e, opts) { // BAT-4905
        setTimeout(function () {
          // GIVE IT A SECOND OR TWO TO DRAW.
          var nextOffer = $('#isotope-offers .card.offer').eq(currentOffersNum).find('a'); // .find('.favorite-button'); // .find('a');
          nextOffer.focus();
        }, 2000);
      });

      $(allOffersCompleteAjax).on('COMPLETE', function (event, $newItems, data) {
        $isotopeContainer.isotope('remove', $isotopeContainer.find('.isotope-item'));
        $isotopeContainer.isotope('insert', $newItems);
        $isotopeContainer.isotope({
          sortBy: 'label'
        });
        self.textFitOfferCards();
        $('#showing-number-of-total .number').html(data.numFound);
        allOffersCompleteAjax.checkDisplayShowMore();
        $('.total-found').html(data.numFound);

        $(document).trigger('COMPLETE_FINISH', { // BAT-4905
          data: data
        });
        self.favListeners();
        // BAT-2980. update offer links with filters.
        allOffersFilters.combineFilters();
      });
      allOffersCompleteAjax.init();
    });

    if (self.offerFrame) {
      allOffersPrintAjax.init();
      $(allOffersPrintAjax).on('COMPLETE', function (event, $newItems) {
        $.each($newItems, function (idx, val) {
          elements.push($(val).get(0));
        });
        self.iframeListeners(elements);
      });
    }

    anClicks(this.getScope());
  },

  iframeListeners: function (elements) {
    var $isotopePrintContainer = $('#print-isotope-offers');

    function fnPrintDetail() {
      var d = new Date();
      var e = __formatDate(d);
      var cashText = '';
      var offerText = '';
      var bulletText = '';
      var callText = '';
      var disclaimerText = '';
      var imageText = '';
      var modalTitle = $('.modal-title').text();
      var leaseText = '';

      if ($('.vehicle-img-wrap').find('.marg-bottom-4-sm').find('.marg-bottom-4-sm').html() != 'undefined' && $('.vehicle-img-wrap').find('.marg-bottom-4-sm').find('.marg-bottom-4-sm').html() != null && $('.vehicle-img-wrap').find('.marg-bottom-4-sm').find('.marg-bottom-4-sm').html() != '' && $.trim($('.vehicle-img-wrap').find('.marg-bottom-4-sm').find('.marg-bottom-4-sm').html()) != '' && typeof $('.vehicle-img-wrap').find('.marg-bottom-4-sm').find('.marg-bottom-4-sm').html() !== 'undefined') {
        cashText = '<span style="margin-left:200px">' + $('.vehicle-img-wrap').find('.marg-bottom-4-sm').find('.marg-bottom-4-sm').html() + '</span>';
      }
      if ($('.marg-bottom-6-sm').html() != 'undefined' && $('.marg-bottom-6-sm').html() != null && $('.marg-bottom-6-sm').html() != '' && $.trim($('.marg-bottom-6-sm').html()) != '' && typeof $('.marg-bottom-6-sm').html() !== 'undefined') {
        offerText = '<span style="margin-left:200px">' + $('.marg-bottom-6-sm').html() + '</span>';
      }
      if ($('.col-md-5').html() != 'undefined' && $('.col-md-5').html() != null && $('.col-md-5').html() != '' && $.trim($('.col-md-5').html()) != '' && typeof $('.col-md-5').html() !== 'undefined') {
        bulletText = '<div style="margin-left:20px">' + $('.col-md-5').html() + '</div>';
      }

      // Lease offers
      if (modalTitle != 'undefined' && modalTitle != null && modalTitle != '' && modalTitle != '' && typeof modalTitle !== 'undefined' && modalTitle.indexOf('lease') != -1) {
        leaseText = '<div id="offer-detail" style="margin-left:200px">' + $('.vehicle-img-wrap').children().children('.col-sm-12').html() + '</div>';
        // NCA-232, drop cashText, since it's already included within leaseText
        cashText = '';
      }
      if ($('.offer-detail-modal-cta').parent('div').html() != 'undefined' && $('.offer-detail-modal-cta').parent('div').html() != null && $('.offer-detail-modal-cta').parent('div').html() != '' && $.trim($('.offer-detail-modal-cta').parent('div').html()) != '' && typeof $('.offer-detail-modal-cta').parent('div').html() !== 'undefined') {
        callText = '<div style="margin-left:20px">' + $('.offer-detail-modal-cta').parent('div').html() + '</div>';
      }

      if ($('.disclaimers-panel').html() != 'undefined' && $('.disclaimers-panel').html() != null && $('.disclaimers-panel').html() != '' && $.trim($('.disclaimers-panel').html()) != '' && typeof $('.disclaimers-panel').html() !== 'undefined') {
        disclaimerText = '<br/><div style="margin-left:10px"><div class="col-md-12 marg-top-4-sm font--1 color-lightest text-left"><strong>Disclaimers</strong></div>' + $('.disclaimers-panel').html() + '</div>';
      }

      if ($('.valign-middle-md').find('img').attr('src') != 'undefined' && $('.valign-middle-md').find('img').attr('src') != null && $('.valign-middle-md').find('img').attr('src') != '' && $.trim($('.valign-middle-md').find('img').attr('src')) != '' && typeof $('.valign-middle-md').find('img').attr('src') !== 'undefined') {
        imageText = '<div style="margin-left:150px"><img src="' + $('.valign-middle-md').find('img').attr('src') + '"></img></div>';
      }
      var newWindow = window.open('', 'print_detail', 'width=800,height=800,scrollbars=1,resizable=1');
      var html = '<!DOCTYPE html><html><head><META http-equiv="Content-Type" content="text/html; charset=UTF-8"><title>Toyota Dealer Association Offers Frame</title><link href="/assets/css/all.css" rel="stylesheet" type="text/css"><style>body{margin-left: 20px !important;}.disclaimers-link{display:none !important}</style></head><body style="background-color: white"><div id="" style="width: 950px; height: 60px;" class=""><span><p><img height="60" alt="Frame Banner" src="http://buyatoyota.com/img/landing/dealer_offers_frame/movingForwardLogo.jpg" title="Toyota Page Banner"></p></span></div><p><span style="color: #9a0f14; font-family: Verdana, Geneva, sans-serif; font-size: 24px; font-style: normal; font-variant: normal; font-weight: bold; letter-spacing: normal; line-height: normal; orphans: auto; text-align: start; text-indent: 0px; text-transform: none; white-space: normal; widows: auto; word-spacing: 0px; -webkit-text-stroke-width: 0px; display: inline !important; float: none;">TOYOTA SPECIAL OFFERS</span></p><div style="margin-left:20px"><h2 class="modal-title font-bold">' + $('.modal-title').text() + '</h2><div>Printed - <span id="curr_time">' + e + '</span></div>' + $('.text-right-md').html() + '</div><br style="clear:both"><br style="clear:both"><br style="clear:both">' + offerText + '<br style="clear:both"><br style="clear:both">' + leaseText + cashText + imageText + bulletText + callText + disclaimerText;
      newWindow.document.open();
      newWindow.document.write(html);
      newWindow.document.close();
      setTimeout(function () {
        newWindow.print();
      }, 1500);
    }

    // since no more inline offers template HBS, need to apply this click event to each offer, via .border-all
    $('body').on('click', '.border-all', function (e) {
      e.preventDefault();
      var id = $(this).closest('.card').attr('id');
      var $modalInner = $('#offer-card-in-iframe-modal-inner');
      var data = bat.OFFER_DETAIL_MODAL[id];
      var handlebarsHTML = bat.hcompile($('#template-offer-detail-modal').html(), data);
      $modalInner.empty().append(handlebarsHTML);
      $('#print_detail img').attr('style', '');
      $('#offer-card-in-iframe-modal').modal('show');

      // fnPrintDetail links
      $('a.js-print-detail').on('click', fnPrintDetail);
    });

    $('#print_dealer_frame').on('click', function () {
      elements.forEach(item => $isotopePrintContainer.append(item));
      $.each($('.vehicle-image.lazy-v', $isotopePrintContainer), function () {
        const $this = $(this);
        const img = $this.data('src');
        $this.removeClass('lazy-v').attr('src', img);
      });
      $isotopePrintContainer.find('.card-loading-overlay').remove();
      $isotopePrintContainer.find('a.border-all').remove();

      var d = new Date();
      var e = __formatDate(d);
      var newWindow = window.open('', 'Offers', 'width=800,height=800,scrollbars=1,resizable=1');
      var html = `
        <!DOCTYPE html><html><head>
          <META http-equiv="Content-Type" content="text/html; charset=UTF-8">
            <title>Toyota Dealer Association Offers Frame</title>
            <link href="/assets/css/all.css" rel="stylesheet" type="text/css">
            <link href="/assets/css/print-offers.css" rel="stylesheet" type="text/css">
          </head>
          <body>
            <div style="width: 950px; height: 60px;">
              <span><p><img height="60" alt="Frame Banner" src="http://buyatoyota.com/img/landing/dealer_offers_frame/movingForwardLogo.jpg" title="Toyota Page Banner"></p></span>
            </div>
            <p>
              <span style="color: #9a0f14; font-family: Verdana, Geneva, sans-serif; font-size: 24px; font-style: normal; font-variant: normal; font-weight: bold; letter-spacing: normal; line-height: normal; orphans: auto; text-align: start; text-indent: 0px; text-transform: none; white-space: normal; widows: auto; word-spacing: 0px; -webkit-text-stroke-width: 0px; display: inline !important; float: none;">TOYOTA SPECIAL OFFERS</span></p>
            Printed - <span id="curr_time">${e}</span>
            <div style="float:none !important" class="pull-right-md pull-left-sm marg-right-4-sm">
              <span class="font-3 found">
                <span class="total-found font-bold">${$isotopePrintContainer.find('div.card').length}</span> <span class="font-light color-light plural"> offers found</span>
              </span>
            </div>
            <div style="height: 1290px; position: relative; overflow: visible;" id="print-isotope-offers" class="isotope-container run-isotope grid layout-lg isotope">
              ${$isotopePrintContainer.html()}
            </div>
          </body>
        `;

      newWindow.document.open();
      newWindow.document.write(html);
      newWindow.document.close();
      setTimeout(function () {
        newWindow.print();
      }, 1500);
    });
  },

  getScope: function () {
    var $vehiclePage = $('#offers-vehicle-page');
    if (this.offerFrame) {
      return $('div[data-component-skin="Framed Offers"]');
    }
    if ($vehiclePage.length) {
      // TODO: stop doing this data shuffle on the side
      // argggh. that km-rab-download link needs to be moved and styled in the XSL
      $vehiclePage.parent('div').data('anctx', $vehiclePage.data('anctx'));
      return $vehiclePage.parent('div');
    }
    return $('#all-offers'); // handles the homepage skin or all-offers skin
  },

  analyticsContext: function (count, filters) {
    var strFilters = filters.join(',');
    var finalFilters = strFilters === '*' ? '' : strFilters.replace(/\./g, '');
    var $scope = this.getScope();
    anAddContext(
      $scope,
      blocks.offerListBlock({
        count: count,
        layout: $('#list-button').hasClass('active') ? 'list' : 'grid',
        filter: finalFilters,
        selector: finalFilters
      })
    );
    if (__initialized) {
      anComponentView($scope);
    } else {
      anComponentView($scope, blocks.keyMetrics('km-offers-search'));
    }
  },

  favListeners: function () {
    var self = this;
    var $scope = this.getScope();
    var $favButton = $('.favorite-button', $scope);
    if (rtiDealerCode.hasRti()) {
      $favButton.hide();
      let dgOffersFinal = {};
      $favButton.each(function () {
        var $this = $(this);
        var id = $this.data('id');
        let fnd = self.dgOffers.find(function (off) { return off.offerId == id; });
        if (fnd) {
          var idF = 'dg-inline-saves-offer-' + id;
          dgOffersFinal[idF] = fnd;
          var $dgInlineOffer = $(idF);
          if ($dgInlineOffer.length == 0) {
            $this.before($('<div/>', { id: idF }));
          }
        }
      });
      if (window.DGDataHub && window.DGDataHub.renderInlineSaves) {
        window.DGDataHub.renderInlineSaves(dgOffersFinal);
      }
    } else {
      $favButton.each(function () {
        var $this = $(this);
        favorites.markFav($this);
        $this.off('click.fav').on('click.fav', function favClick(e) {
          var note = $this.siblings('#favorite-action');
          var addToFavs = langFromUrl() === 'en' ? 'Offer added to favorites' : 'Oferta añadida en favoritos';
          var removeFromFavs = langFromUrl() === 'en' ? 'Offer removed from favorites' : 'Oferta eliminada de favoritos';

          if (note.text() === addToFavs) {
            note.text(removeFromFavs);
          } else {
            note.text(addToFavs);
          }
          e.preventDefault();
          favorites.addRemove($this);
        });
      });
    }
  },

  // TODO: get rid of this garbage
  textFitOfferCards: function () {
    $('.card .trim.textfit, .card .name.textfit').each(function (index, item) {
      // BAT-2757.
      $(item).removeAttr('style');
      setTimeout(function () {
        var tow = $(item).outerWidth();
        var offertypeWidth = 0;
        var siblings = $(item).siblings();
        siblings.each(function (idx, sib) {
          sib = $(sib);
          // OFFER-TYPE
          if (sib.hasClass('offer-type')) {
            offertypeWidth = sib.width(); // NEED THIS FOR CALCS.
          }
          // MODEL
          if (sib.hasClass('model') || sib.hasClass('trim')) {
            var mow = sib.outerWidth();
            /*
              tow =  the item width
              mow = .model width
              offertypeWidth = the width of the offer type element.  it is 100% so we grab that width to measure against.
            */
            if (mow + tow > offertypeWidth) {
              $(item).css('width', '100%');
              $(item).css('display', 'block');
            } else {
              $(item).css('width', 'auto');
              $(item).css('display', 'inline');
            }
          }
        });
      }, 500);
    });
    // BAT-2760, .textfit plugin now works, we can use it on .descriptions (only present on MISC offers)
    $('.card .description.textfit').textFit({
      alignHoriz: false,
      // alignVert: true,
      minFontSize: 13,
      maxFontSize: 20,
      alignVertWithFlexbox: true
    });

    // BAT-3846 HANDLES SPACE BAR FOR OFFER CARDS.
    $('.card .card-content a').each(function(index, item){
      $(item).off().keydown(function(event){
        if(event.keyCode === 32) {
          // KEYBOARD CONTROL TO GO TO OFFER DETAIL:
          event.preventDefault();
          if (event.target.href) {
            window.location.href = event.target.href;
          }
        }
        return;
      });
    })
  }
};

export default allOffers;
